import { useGetAllFeatureFlagQuery } from '../features/featureFlag/featureFlagApi';
import { END_USER_LICENSE_ACTIVATION_FEATURE_FLAG } from '../constants';
import { FeatureFlagData } from '../types';

/**
 * Reads the `EndUserLicenceActivation` feature flag from the feature-flags API.
 *
 * @param enabled - When `true` (default) the underlying feature-flags query runs.
 *   When `false`, the query is skipped (no network request) and the hook reports
 *   the flag as disabled and not loading.
 * @returns An object with:
 *   - `isEndUserLicenseActivationEnabled` - `true` only when the flag exists and is enabled.
 *   - `isFlagLoading` - `true` while the feature-flags query is in flight; always `false` when `enabled` is `false`.
 */
export const useEndUserLicenseActivationFlag = (
    enabled = true
): { isEndUserLicenseActivationEnabled: boolean; isFlagLoading: boolean } => {
    const { data: featureFlags, isLoading } = useGetAllFeatureFlagQuery({}, { skip: !enabled });
    const flag = featureFlags?.data?.find(
        (f: FeatureFlagData) => f.featureFlagName === END_USER_LICENSE_ACTIVATION_FEATURE_FLAG
    );
    return { isEndUserLicenseActivationEnabled: Boolean(flag?.enabled), isFlagLoading: isLoading };
};
